var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product flex-center"},[_c('c-file',{staticStyle:{"width":"42px","height":"42px"},attrs:{"media":"","src":_vm.image}}),_c('p',{staticClass:"flex-grow ellipsis-2",staticStyle:{"margin-left":"12px"}},[_vm._v(_vm._s(_vm.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }